import {
  EMPLOYMENT_TYPE_CONSULTANT,
  EMPLOYMENT_TYPE_SIMFLEXITY_EMPLOYEE,
  EMPLOYMENT_TYPE_TRAINEE,
} from "model/OrganizationalStructure";

interface EmploymentFieldVisibility {
  showContractTerms: boolean;
  showEmployeeCategory: boolean;
  showPaymentType: boolean;
  showSalary: boolean;
  showSalaryType: boolean;
  showTaxTable: boolean;
}

const normalizeEmploymentType = (
  employmentType: string | null | undefined,
): string => {
  return (employmentType ?? "").trim().toLowerCase();
};

export const getEmploymentFieldVisibility = (
  employmentType: string | null | undefined,
): EmploymentFieldVisibility => {
  const normalizedEmploymentType = normalizeEmploymentType(employmentType);
  const isSimflexityEmployee =
    normalizedEmploymentType ===
    EMPLOYMENT_TYPE_SIMFLEXITY_EMPLOYEE.toLowerCase();
  const isTraineeOrConsultant =
    normalizedEmploymentType === EMPLOYMENT_TYPE_TRAINEE.toLowerCase() ||
    normalizedEmploymentType === EMPLOYMENT_TYPE_CONSULTANT.toLowerCase();

  if (isTraineeOrConsultant) {
    return {
      showSalaryType: false,
      showSalary: false,
      showPaymentType: false,
      showTaxTable: false,
      showEmployeeCategory: false,
      showContractTerms: false,
    };
  }

  if (isSimflexityEmployee) {
    return {
      showSalaryType: true,
      showSalary: true,
      showPaymentType: true,
      showTaxTable: false,
      showEmployeeCategory: false,
      showContractTerms: false,
    };
  }

  return {
    showSalaryType: true,
    showSalary: true,
    showTaxTable: true,
    showPaymentType: true,
    showEmployeeCategory: true,
    showContractTerms: true,
  };
};
